import React from 'react';
import { Box, Typography } from '@mui/material';
import { TreeView, TreeItem } from '@mui/x-tree-view';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderIcon from '@mui/icons-material/Folder';
import { CameraUploadFolder, UNCLASSIFIED_FOLDER } from '../../api/cameraUpload';

interface ClassificationTreeProps {
  folders: CameraUploadFolder[];
  selected: string | null;
  onSelect: (className: string) => void;
}

const ClassificationTree: React.FC<ClassificationTreeProps> = ({ folders, selected, onSelect }) => {
  if (folders.length === 0) {
    return <Typography color="text.secondary">No sorted photos yet — upload a zip to get started.</Typography>;
  }

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      selected={selected ?? ''}
      onNodeSelect={(_e, nodeId) => onSelect(nodeId)}
    >
      {folders.map((folder) => (
        <TreeItem
          key={folder.className}
          nodeId={folder.className}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
              <FolderIcon fontSize="small" color="action" />
              <Typography variant="body2" sx={{ flexGrow: 1 }}>
                {folder.className === UNCLASSIFIED_FOLDER ? 'Unclassified' : folder.className}
              </Typography>
              <Typography variant="caption" color="text.secondary">{folder.count}</Typography>
            </Box>
          }
        />
      ))}
    </TreeView>
  );
};

export default ClassificationTree;
